import "./styles/fonts.css";
import {
  Alert,
  Button,
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider
} from "@mui/material";
import { DialogProvider } from "muibox";
import { SnackbarProvider } from "notistack";
import React from "react";
import ReactDOM from "react-dom";
import { ReactQueryDevtools } from "react-query/devtools";
import App from "./app/App";
import { LoadingProvider } from "./components/loading/LoadingProvider";
import PostMessage from "./components/post-message/PostMessage";
import CustomQueryClientProvider from "./CustomQueryClientProvider";
import { identificarAmbiente } from "./shared/ambiente";
import { HABILITA_REACT_QUERY_DEVTOOLS } from "./shared/env";
import { initKeycloak } from "./shared/keycloak";
import theme from "./shared/theme";

const habilitaReactQueryDevtools = HABILITA_REACT_QUERY_DEVTOOLS === "S";

function renderApp() {
  ReactDOM.render(
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <DialogProvider>
          <SnackbarProvider maxSnack={1}>
            <LoadingProvider>
              <CustomQueryClientProvider>
                <CssBaseline />
                <PostMessage>
                  <App />
                </PostMessage>
                {habilitaReactQueryDevtools && (
                  <ReactQueryDevtools initialIsOpen={false} />
                )}
              </CustomQueryClientProvider>
            </LoadingProvider>
          </SnackbarProvider>
        </DialogProvider>
      </ThemeProvider>
    </StyledEngineProvider>,
    document.getElementById("root")
  );
}

initKeycloak()
  .then(renderApp)
  .catch((error) => {
    ReactDOM.render(
      <Alert
        severity="error"
        action={
          <Button onClick={() => window.location.reload()}>
            Tentar novamente
          </Button>
        }
      >
        {error.message}
      </Alert>,
      document.getElementById("root")
    );
  });

document.title = `Conector Esocial - ${identificarAmbiente()}`;
